import { Observable } from 'rxjs';
import { switchMap, tap } from 'rxjs/operators';
import type { ArdoqId } from '@ardoq/api-types';
import { api, handleError, transformationsApi } from '@ardoq/api';
import { action$, extractPayload, ofType } from '@ardoq/rxbeach';
import { trackEventV2 } from 'tracking/tracking';
import { deleteFutureStateRequested } from '../futureStatePage/actions';
import { dispatchDetectedSetupStatus } from '../setupStatusDetection';

export const deleteFutureState$: Observable<ArdoqId> = action$.pipe(
  ofType(deleteFutureStateRequested),
  extractPayload(),
  switchMap(transformationsApi.deleteFutureState),
  handleError(error => {
    dispatchDetectedSetupStatus(error);
    api.logErrorIfNeeded(error);
  }),
  tap(() => trackEventV2({ event: 'Future State0 Deleted future state' }))
);
